import React from "react";
import Skeleton from "../../components/Skeleton/Skeleton";

const ActivationSkeleton: React.FC = () => {
  return (
    <>
      <div className="text-center auth-title-form">
        <Skeleton
          width={200}
          height={20}
          className="mx-auto"
          animation={"enabled"}
        />
      </div>

      <div className="card-body">
        <div>
          <Skeleton
            width={220}
            height={20}
            className="mb-1"
            animation={"enabled"}
          />
          <Skeleton height={48} className="w-100" animation={"enabled"} />
        </div>

        <div className="mb-4">
          <Skeleton height={20} width={140} animation={"enabled"} />
        </div>

        <div className="mb-2">
          <Skeleton height={48} className="w-100" animation={"enabled"} />
        </div>

        <div className="p-3 text-center pb-5">
          <Skeleton
            width={220}
            height={20}
            className="mx-auto"
            animation={"enabled"}
          />
        </div>
      </div>
    </>
  );
};

export default ActivationSkeleton;
